/* eslint-disable react/jsx-pascal-case */
import { connect } from 'react-redux';
// import { CardXlContent } from 'components/blocks/CardXl';
import uiStruct from 'constants/uiStruct';
import translations from 'constants/translations';
import { handleRowReverse } from 'helpers/FEutils';
import CardXlEditDelete from 'components/blocks/CardXlEditDelete';
import { CardXlDragHandleItem } from 'components/blocks/CardXl';
import AccomodationDaysSelect from 'components/blocks/AccomodationDaysSelect';
import FeedbackBox from './FeedbackBox';

function CircleListItem({
    objId,
    byDay = 'initial',
    edit,
    globalState: {
        lang,
        isPublishedView,
        isAdminStaff,
        isOwner,
        isFeedbackMode
    },
    accommInfo,
    defaultHtml = 'Amine tanslate',
    hintObj = uiStruct.itinerary.activities.uiEdit.modals.description.hint,
    icon = uiStruct.itinerary.activities.uiEdit.modals.description.icon,
    nohover = null,
    provided = { draggableProps: [], innerRef: '' },
    handleDeleteBtnAction,
    index,
    handleClickBtnAction,
    handleDayUpdate
}) {
    const rtl = !!translations[lang].rtl;
    const handleEdit = (e) => {
        handleClickBtnAction(index, 'circle');
    };
    const {
        label,
        circle: {
            location: { lat, lng }
        }
    } = accommInfo;
    // const googleMapLink = (
    //     <a
    //         href={`https://maps.google.com/?q=${lat},${lng}&ll=${lat},${lng}&z=16`}
    //         rel='noreferrer'
    //         target='_blank'
    //         className={`${
    //             label
    //                 ? 'text-sm underline-none'
    //                 : 'text-sm italic text-gray-400'
    //         }`}
    //     >
    //         {label}
    //     </a>
    // );

    const googleMapLink = `https://maps.google.com/?q=${lat},${lng}&ll=${lat},${lng}&z=16`;

    const handleDelete = () => {
        handleDeleteBtnAction(index);
    };

    const handleDayUpdateAction = (data) => {
        const days = data
            .map((day) => {
                return day.value;
            })
            .sort((a, b) => a - b);

        handleDayUpdate(days, index);
    };

    const makeDays = () => {
        if (byDay !== 'initial') {
            return null;
        }
        const { days } = accommInfo;

        if (days) {
            return (
                <div className='mt-6 flex gap-2 items-center flex-wrap'>
                    {days.map((day) => {
                        const key = `Day${day}`;
                        return (
                            <div
                                key={key}
                                className={`text-gray-900 group text-xs bg-white flex flex-shrink-0 gap-2 flex-nowrap items-center hover:bg-blue-200 rounded-full px-3 py-0.5 ${
                                    handleRowReverse(rtl).flex
                                }`}
                            >
                                <i className='group-hover:text-blue-700 text-blue-400 text-lg ri-check-line'></i>

                                <span
                                    className={`break-all ${
                                        handleRowReverse(rtl).text
                                    }`}
                                >
                                    Day {day}
                                </span>
                            </div>
                        );
                    })}
                </div>
            );
        }
        return null;
    };

    const openLink = () => {
        if (edit) return null;
        else return window.open(googleMapLink, '_blank', 'noopener,noreferrer');
    };

    return (
        <li
            className={`mb-4 sm:items-start relative flex group flex-col  ${
                rtl ? 'kn-rtl sm:kn-ltr' : ''
            } sm:flex-row py-5 px-4 w-full  bg-blue-50 hover:bg-blue-100
            } transition-colors ease-in-out duration-300 rounded-3xl sm:${
                handleRowReverse(rtl).flex
            }`}
            ref={provided.innerRef}
            {...provided.draggableProps}
        >
            <div
                onClick={openLink}
                className={`w-full h-full ${edit ? '' : 'cursor-pointer'}`}
            >
                <span className='absolute right-4 top-4'>
                    <i className='ri-map-pin-line text-xl text-blue-600'></i>
                </span>
                {edit && !isFeedbackMode && (
                    <>
                        <CardXlEditDelete
                            handleDelete={handleDelete}
                            handleEdit={handleEdit}
                            colors={uiStruct.ui.tip_list.UI_LBL_NOTE}
                            rtl={rtl}
                        />
                    </>
                )}
                <CardXlDragHandleItem
                    dragOff={!edit || isFeedbackMode}
                    dragProps={provided.dragHandleProps}
                    rtl={rtl}
                />

                <div className='flex flex-col md:flex-row md:items-center gap-4 md:gap-0'>
                    <div>
                        <span className='px-4 py-1 bg-blue-200 text-blue-800 text-sm rounded-full whitespace-nowrap font-bold italic mr-4'>
                            Region
                        </span>
                    </div>
                    <div className='px-2 '>
                        <span className='mr-4 text-sm underline-none'>
                            {label}
                        </span>
                    </div>
                </div>
                {edit && !isFeedbackMode ? (
                    <AccomodationDaysSelect
                        key={`day${Math.random()}`}
                        handleDayUpdate={handleDayUpdateAction}
                        days={accommInfo.days}
                        index={index}
                    />
                ) : (
                    makeDays()
                )}
            </div>
            <FeedbackBox
                objId={objId}
                label='Accommodation'
                isAdminStaff={isAdminStaff}
                isPublishedView={isPublishedView}
                isOwner={isOwner}
            />
        </li>
    );
}

const mapStateToProps = (state) => ({
    globalState: state.globalState
});

export default connect(mapStateToProps, null)(CircleListItem);
